module.exports = __webpack_public_path__ + "img/title.d2cf85a3.png";